import { TransactionTemplate } from '../types/journalEntry';
import { RestrictionType } from '../types/accounting';

export const TRANSACTION_TEMPLATES: TransactionTemplate[] = [
  {
    id: 'admin_expense',
    name: 'Administrative Expense',
    description: 'Record administrative expenses',
    type: 'standard',
    defaultEntries: [
      {
        accountId: '5200', // Administrative Expenses
        description: 'Administrative cost',
        isDebit: true,
        taxCategory: 'EXP_MGMT'
      },
      {
        accountId: '1000', // Cash
        description: 'Payment for administrative expenses',
        isDebit: false,
        taxCategory: 'EXP_MGMT'
      }
    ],
    lineItems: []
  },
  {
    id: 'donation_receipt',
    name: 'Donation Receipt',
    description: 'Record incoming donation',
    type: 'standard',
    defaultEntries: [
      {
        accountId: '1000', // Cash
        description: 'Donation received',
        isDebit: true,
        taxCategory: 'REV_CONTRIB'
      },
      {
        accountId: '4000', // Contribution Revenue
        description: 'Contribution revenue recognition',
        isDebit: false,
        taxCategory: 'REV_CONTRIB'
      }
    ],
    lineItems: []
  },
  {
    id: 'grant_receipt',
    name: 'Grant Receipt',
    description: 'Record incoming grant funding',
    type: 'standard',
    defaultEntries: [
      {
        accountId: '1000', // Cash
        description: 'Grant funding received',
        isDebit: true,
        taxCategory: 'REV_CONTRIB',
        fundRestriction: RestrictionType.TEMPORARILY_RESTRICTED
      },
      {
        accountId: '4100', // Grant Revenue
        description: 'Grant revenue recognition',
        isDebit: false,
        taxCategory: 'REV_CONTRIB'
      }
    ],
    lineItems: []
  },
  {
    id: 'payroll',
    name: 'Payroll Entry',
    description: 'Record payroll expenses',
    type: 'standard',
    defaultEntries: [
      {
        accountId: '5100', // Salary Expense
        description: 'Gross salary',
        isDebit: true,
        taxCategory: 'EXP_MGMT'
      },
      {
        accountId: '2100', // Payroll Liabilities
        description: 'Payroll tax withholding',
        isDebit: false,
        taxCategory: 'EXP_MGMT'
      },
      {
        accountId: '1000', // Cash
        description: 'Net pay',
        isDebit: false,
        taxCategory: 'EXP_MGMT'
      }
    ],
    lineItems: []
  },
  {
    id: 'program_expense',
    name: 'Program Expense',
    description: 'Record program-related expenses',
    type: 'standard',
    defaultEntries: [
      {
        accountId: '5000', // Program Expenses
        description: 'Program service delivery',
        isDebit: true,
        taxCategory: 'EXP_PROGRAM'
      },
      {
        accountId: '1000', // Cash
        description: 'Payment for program expenses',
        isDebit: false,
        taxCategory: 'EXP_PROGRAM'
      }
    ],
    lineItems: []
  }
]; 